import React from "react";
import styled from "styled-components";
import ModalBasic from "./ModalBasic.jsx";
import welcomeImage from "../../img/pc_signup_celebration_popup.png";

const ModalThankLowGrant = ({
  isOpen,
  onConfirm,
  messageTitle,
  messageSubtitle,
  confirmText = "확인",
  isConfirmDisabled = false,
}) => {
  return (
    <ModalBasic
      isOpen={isOpen}
      width={window.innerWidth > 430 ? "400px" : "312px"}
      height={window.innerWidth > 430 ? "363px" : "296px"}>
      <ContentWrapper>
        <ImageWrapper>
          <WelcomeImage
            src={welcomeImage}
            alt="감사함을 표시하기 위한 로우 지급 모달창"
          />
        </ImageWrapper>
        <TextWrapper>
          <Message>
            {messageTitle}
            <br />
            {messageSubtitle}
          </Message>
        </TextWrapper>
        <ButtonStyles
          onClick={onConfirm}
          disabled={isConfirmDisabled}>
          {confirmText}
        </ButtonStyles>
      </ContentWrapper>
    </ModalBasic>
  );
};
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 195px;
  background: #f0f0f0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  @media (max-width: 430px) {
    height: 152px;
  }
`;

const WelcomeImage = styled.img`
  width: 100%;
  height: 100%;
  margin: 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;

  @media (max-width: 430px) {
    padding: 16px;
  }
`;

const Message = styled.div`
  color: #000;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;

  @media (max-width: 430px) {
    font-size: 16px;
    font-weight: 700;
    line-height: 26px;
  }
`;

const ButtonStyles = styled.button`
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  margin-left: 8px;
  border: none;
  background-color: #f0f0f0;
  border-radius: 6px;
  background: #000;
  color: #00f370;
  font-style: normal;
  font-size: 16px;
  width: 70px;
  height: 40px;
  margin: 0; /* 버튼의 기본 marigin 0으로 설정*/
  margin-bottom: 24px;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  @media (max-width: 430px) {
    width: 66px;
    height: 36px;
    color: #00f370;
    font-size: 14px;
    font-weight: 500;
    line-height: 30px;
    margin-bottom: 20px;
  }
`;

export default ModalThankLowGrant;
